import { Injectable, inject, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { PractiseBookPageActions } from './practise.actions';
import {
  selectBookTocVM,
  selectFinalExamVM,
  selectPaginationVM,
  selectParagraphVM,
} from './practise-vm.selectors';
import {
  Book,
  BookSwitchData,
  BookTocVM,
  ExaminationSession,
  Exercise,
  FinalExamVM,
  PaginationVM,
  Paragraph,
  ParagraphVM,
  Video,
} from '@lyceo/lyceo-pupil-app/practise/util-models';
import { AutocompleteOption, ExerciseResult } from '@lyceo/shared/util-models';
import { selectSingleBookSwitches } from './practise.selectors';

@Injectable({
  providedIn: 'root',
})
export class PractiseBookFacade {
  private readonly store: Store = inject(Store);

  public readonly singleBookSwitches: Signal<BookSwitchData[]> =
    this.store.selectSignal(selectSingleBookSwitches);
  public readonly paginationVM: Signal<PaginationVM> =
    this.store.selectSignal(selectPaginationVM);
  public readonly bookTocVM: Signal<BookTocVM> =
    this.store.selectSignal(selectBookTocVM);
  public readonly paragraphVM: Signal<ParagraphVM> =
    this.store.selectSignal(selectParagraphVM);
  public readonly finalExamVM: Signal<FinalExamVM> =
    this.store.selectSignal(selectFinalExamVM);

  public init(): void {
    this.store.dispatch(PractiseBookPageActions.init());
  }

  public paragraphClicked(paragraph: Paragraph): void {
    this.store.dispatch(
      PractiseBookPageActions.paragraphClicked({ paragraph }),
    );
  }

  public paginationParagraphClicked(paragraph: Paragraph): void {
    this.store.dispatch(
      PractiseBookPageActions.paginationParagraphClicked({ paragraph }),
    );
  }

  public paginationLastParagraphClicked(paragraph: Paragraph): void {
    this.store.dispatch(
      PractiseBookPageActions.paginationLastParagraphClicked({ paragraph }),
    );
  }

  public paginationFinalExamClicked(book: Book): void {
    this.store.dispatch(
      PractiseBookPageActions.paginationFinalExamClicked({ book }),
    );
  }

  public finalExamClicked(book: Book): void {
    this.store.dispatch(PractiseBookPageActions.finalExamClicked({ book }));
  }

  public readTheoryClicked(readTheory: boolean): void {
    this.store.dispatch(
      PractiseBookPageActions.readTheoryClicked({ readTheory }),
    );
  }

  public exerciseClicked(exercise: Exercise): void {
    this.store.dispatch(PractiseBookPageActions.exerciseClicked({ exercise }));
  }

  public viewExerciseResultClicked(
    exerciseResult: ExerciseResult<ExaminationSession>,
  ): void {
    this.store.dispatch(
      PractiseBookPageActions.viewExerciseResultClicked({ exerciseResult }),
    );
  }

  public finalExamExerciseClicked(book: Book): void {
    this.store.dispatch(
      PractiseBookPageActions.finalExamExerciseClicked({ book }),
    );
  }

  public videoWatched(video: Video): void {
    this.store.dispatch(PractiseBookPageActions.videoWatched({ video }));
  }

  public videoPlayClicked(video: Video): void {
    this.store.dispatch(PractiseBookPageActions.videoPlayClicked({ video }));
  }

  public searchParagraphClicked(item: AutocompleteOption | undefined): void {
    this.store.dispatch(
      PractiseBookPageActions.searchParagraphClicked({ item }),
    );
  }

  public searchParagraphValue(searchString: string): void {
    this.store.dispatch(
      PractiseBookPageActions.searchParagraphValue({ searchString }),
    );
  }
}
